import React, { Component } from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';
import PreviewModal from './Modal';

class ImagePreviewToggled extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal() {
    this.setState(state => ({ visible: !state.visible }));
  }

  render() {
    const className = classNames('u-linkBtn', {
      [this.props.className]: !!this.props.className,
    });

    const message = this.props.message ? this.props.message : '';

    return (
      <>
        <button type="button" className={className} onClick={this.toggleModal}>
          <Icon name="photo" /> {message}
        </button>
        {this.state.visible && (
          <PreviewModal
            image={this.props.image}
            imageType={this.props.imageType}
            isCertification={this.props.isCertification}
            onDismiss={this.toggleModal}
          />
        )}
      </>
    );
  }
}

export default ImagePreviewToggled;
